import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import Header from '@/components/globals/Header';
import Wizard from '@/components/shared/Wizard';
import { useFlowTracker } from '@/hooks/useFlowTracker';
import { AvailableSearchParams, getSearchParam } from '@/lib/params';
import { productStore } from '@/stores/productStore';
import { type Step, stepStore } from '@/stores/steps';

import { start } from './steps';

const CreateProduct = () => {
  const navigate = useNavigate();

  const goBackHiddenContentList = useMemo(() => {
    const isApp = getSearchParam(AvailableSearchParams.APP) === 'true';

    if (!isApp) {
      return [];
    }

    const flow = getSearchParam(AvailableSearchParams.FLOW);

    if (flow === 'ebook') {
      return ['start', 'upload_chat_question_1', 'upload_answer_files'] as Step['content'][];
    }

    return [
      'start',
      'chat_question_request',
      'chat_answer_request',
      'qualification_chat_question_transition',
      'select_product'
    ] as Step['content'][];
  }, []);

  useFlowTracker({
    flow: 'create_ebook_v0',
    dataMapper: () => ({ ...productStore.getState(), image: undefined, producer: undefined })
  });

  return (
    <Wizard steps={[...start]}>
      <Header
        goBackHiddenContentList={goBackHiddenContentList}
        onGoBack={() => stepStore.getState().previousStep({ onStepNotFound: () => navigate('/') })}
        suffix={
          <Wizard.Information
            contentToIgnore={[
              'start',
              'chat_question_request',
              'chat_answer_request',
              'qualification_chat_question_transition'
            ]}
          />
        }
      />
      <Wizard.Progress />
      <Wizard.Steps />
    </Wizard>
  );
};

export default CreateProduct;
